import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import type ContractFlow from 'modules/contracts/lib/ContractFlow'
import type ContractFlowStep from 'modules/contracts/lib/ContractFlowStep'

import { MenuItem } from './_MenuItem'

interface Props {
  flow: ContractFlow
  steps: ContractFlowStep[]
  setCurrentStep: (step: number) => void
}

export const Menu = observer(({ flow, steps, setCurrentStep }: Props) => {
  const currentStep = steps[flow.currentStepNumber]
  return (
    <Box gap="s48" paddingX="s48">
      <Box width="full" gap="s8">
        {steps.map((step, index) => (
          <MenuItem
            flow={flow}
            stepNumber={index}
            key={`${index}-${step}`}
            step={step}
            setCurrentStep={setCurrentStep}
          />
        ))}
      </Box>
      {currentStep?.description && (
        <Box>
          <Text weight="medium" size="200" color="grey1000">
            {currentStep.description}
          </Text>
        </Box>
      )}
    </Box>
  )
})
